import { TaskFieldOption, WorkflowTask } from '../../../models';
import { TaskFieldOptionsResponse, Task as OctopusTask } from '../models';
import { ConfigurationMapper } from './configuration';

export class TaskFieldOptionsMapper extends ConfigurationMapper<
  TaskFieldOptionsResponse,
  TaskFieldOption
> {
  from(source: TaskFieldOptionsResponse): TaskFieldOption {
    const task = source.Task?.FieldOptions;

    return {
      priority: task?.Priority?.map(this.mapKeyAndDisplay) ?? [],
      category: task?.Category?.map(this.mapKeyAndDisplay) ?? [],
      result: task?.Result?.map(this.mapKeyAndDisplay) ?? [],
      assignedTo:
        task?.AssignedTo?.map(this.mapKeyAndDisplay).sort((first, second) =>
          first.name.localeCompare(second.name),
        ) ?? [],
    };
  }
}

export class WorkflowTaskMapper extends ConfigurationMapper<
  OctopusTask[],
  WorkflowTask[]
> {
  from(source: OctopusTask[]): WorkflowTask[] {
    return source.map((item) => ({
      key: item.Key,
      activity: item.Activity ?? null,
      dateTime: item.DateTime.Value,
      completionDate: item.CompletionDate?.Value ?? '',
      assignedTo: item.AssignedTo
        ? this.mapKeyAndDisplay(item.AssignedTo)
        : null,
      abEntry: item.AbEntry
        ? {
            id: item.AbEntry.Key ?? '',
            name: item.AbEntry.DisplayValue,
            type: item.AbEntry.Type,
          }
        : null,
      lead: item.Lead
        ? { id: item.Lead.Key ?? '', name: item.Lead.DisplayValue ?? '' }
        : null,
      workflowInstanceKey: item.WorkflowInstanceKey ?? null,
      workflowTaskTemplateKey: item.WorkflowTaskTemplateKey ?? null,
      priority: item.Priority ?? '',
      completed: item.Completed ?? false,
      recurrence: item.Recurrence ?? null,
    }));
  }
}
